import RegisterPage from './RegisterPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const RegisterPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/register',
      component: RegisterPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/login/RegisterPageConfig.js